function matchesId(tab, tabId) {
    const candidateId = tab.getAttribute('data-about-tab-id');

    return candidateId == tabId;
}

function showTab(tab) {
    tab.classList.add('aboutTab--active');
}

function hideTab(tab) {
    tab.classList.remove('aboutTab--active');
}

function selectTab(button) {
    const tabId = button.getAttribute('data-for-about-tab');
    const tabs = [...document.querySelectorAll('[data-about-tab-id]')];
    
    if (tabId && tabs.length > 0) {
        tabs.filter(tab => matchesId(tab, tabId)).forEach(showTab);
        tabs.filter(tab => !matchesId(tab, tabId)).forEach(hideTab);
    }
}

function selectButton(buttons, activeButton) {
    console.log('selectButton');
    buttons.filter(button => button == activeButton).forEach(button => button.classList.add('aboutTabs__button--active'));
    buttons.filter(button => button != activeButton).forEach(button => button.classList.remove('aboutTabs__button--active'));
}

function init() {
    const buttons = [...document.querySelectorAll('.js_aboutTabs__button')];

    buttons.forEach(button => button.addEventListener('click', e => {
        selectTab(button);
        selectButton(buttons, button);
    }));
}

$(document).ready(init);
